module.exports = __webpack_public_path__ + "components/homepage-hero/static/hero-bg-1200-3ae5f4d4579382e973fd7bb86a4706db.webp";